__webpack_require__.p = "/mall/_next/";